<template>
  <!-- Table Container Card -->
  <b-card>

    <validation-observer ref="creditBureauRules">
      <b-form @submit.prevent="handleSubmit">
        <b-row class="match-height">
          <!-- Reporting Date-->
          <b-col md="5">
            <DatePickerField
              id="reporting-date"
              v-model="creditBureauFormData.reportingDate"
              rules="required"
              :min-date="new Date()"
              :label="$t('Reporting Date')"
              :error-name="$t('Reporting Date')"
              :config="datePickerConfig"
              :placeholder="$t('Select Date')"
            />
          </b-col>
          <!--  Reporting Date -->

          <!-- Period (In Months) -->
          <b-col md="5">
            <InputField
              id="period"
              v-model="creditBureauFormData.period"
              :label="$t('Period (In Months)')"
              :placeholder="$t('Enter Period (In Months)')"
              type="text"
              :error-name="$t('Period (In Months)')"
              rules="required"
              for="period"
              :readonly="isReadonly"
            />
          </b-col>
          <!-- Period (In Months) -->
          <b-col
            md="2"
            class="mt-2"
          >
            <Button
              v-if="getUserPermission('EXPORT_CREDIT_BUREAU_REPORT')"
              :label="$t('Generate')"
              :loading="isLoading"
              :disabled="isDisabled"
              variant="primary"
              size="md"
              @click="handleSubmit"
            />
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    <FullScreenSpinner :show="showSpinner" />
  </b-card>

</template>

<script>
import {
  BCard, BRow, BForm, BCol,
} from 'bootstrap-vue'
import { tableMixins } from '@core/mixins/table'
import { modalMixins } from '@core/mixins/modal'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { permissionMixin } from '@core/mixins/permission'
import { mapActions, mapGetters } from 'vuex'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import {
  toCustomDate, toDateWithDateTime, toDateWithUnderscore, getMinusOneDayDate,
} from '@/helpers/formatDate'
import { toFormatAmount } from '@/helpers/formatAmount'
import InputField from '../../../forms/InputField.vue'
import DatePickerField from '../../../forms/DatePickerField.vue'
import Button from '../../../components/button/Button.vue'
import { reportDataDetail } from '../../../../helpers/data'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    Button,
    InputField,
    DatePickerField,
    ValidationObserver,
    FullScreenSpinner,
  },
  directives: {
    Ripple,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      isBusy: false,
      required,
      toCustomDate,
      toFormatAmount,
      isLoading: false,
      isDisabled: false,
      showSpinner: false,
      reportData: [],
      creditBureauFormData: {
        reportingDate: '',
        period: '',
      },
      reportInfo: reportDataDetail,
      datePickerConfig: {
        dateFormat: 'Y-m-d',
        maxDate: '',
        defaultDate: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      currentFinancialDate: 'operations/getCurrentFinancialDate',
      userDetails: 'auth/getCurrentUser',
    }),
    getInstitutionFinancialDate() {
      return getMinusOneDayDate(this.currentFinancialDate.financialDate)
    },
  },
  mounted() {
    this.datePickerConfig.maxDate = this.getInstitutionFinancialDate
  },
  methods: {
    ...mapActions({
      downloadCreditBureauReport: 'reports/getCreditBrueau',
    }),
    handleSubmit() {
      const action = 'generate'
      this.$refs.creditBureauRules.validate().then(async success => {
        if (success) {
          const areYouSure = this.$t('Are you sure you want to')
          const thisText = this.$t('this Credit Bureau Report?')
          this.confirm(this.exportCreditBureauReport, { text: `${areYouSure} ${action} ${thisText}` })
        }
      })
    },
    async exportCreditBureauReport() {
      try {
        this.isBusy = true
        this.showSpinner = true
        const response = await this.downloadCreditBureauReport(this.creditBureauFormData)
        if (response.status === 200) {
          this.alertSuccessCustom({
            text: 'Your download is in progress and might take a little longer. Go to your',
            link: {
              text: 'Download Manager',
              route: { name: 'download-manager' },
            },
            afterLinkText: ' to access the completed file.',
          })
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isBusy = false
        this.showSpinner = false
      }
    },
    formatToDateWithDateTime: toDateWithDateTime,
    formatToDateUnderscore: toDateWithUnderscore,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
